import { ref } from 'vue';
import { testimonialsService } from '@/services/testimonialsService';

export function useTestimonials() {
  const testimonials = ref([]);
  const testimonialsLoading = ref(true);
  const myTestimonial = ref(null);

  async function fetchTestimonials() {
    try {
      testimonialsLoading.value = true;
      testimonials.value = await testimonialsService.getAll();
    } catch {
      testimonials.value = [];
    } finally {
      testimonialsLoading.value = false;
    }
  }

  async function fetchMyTestimonial() {
    try {
      myTestimonial.value = await testimonialsService.getMine();
    } catch {
      myTestimonial.value = null;
    }
  }

  return {
    testimonials,
    testimonialsLoading,
    myTestimonial,
    fetchTestimonials,
    fetchMyTestimonial,
  };
}
